import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.recaptchaProcessed = false
  }

  async handleSubmit(e) {
    if (this.recaptchaProcessed) {
      return
    }

    const hiddenInput = document.getElementById('recaptcha_enterprise_token')
    const siteKey = document.querySelector('meta[name="recaptcha-site-key"]')?.content
    const submitBtn = this.element.querySelector('input[type="submit"], button[type="submit"]')
    const originalText = submitBtn?.value || submitBtn?.textContent
    
    if (siteKey && window.grecaptcha?.enterprise && hiddenInput) {
      e.preventDefault()
      
      // Show loading state
      if (submitBtn) {
        submitBtn.disabled = true
        if (submitBtn.tagName === 'INPUT') {
          submitBtn.value = 'Loading...'
        } else {
          submitBtn.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Loading...'
        }
      }
      
      try {
        const tokenPromise = new Promise((resolve, reject) => {
          grecaptcha.enterprise.ready(async () => {
            try {
              const t = await grecaptcha.enterprise.execute(siteKey, { action: 'signup' })
              resolve(t)
            } catch (err) {
              reject(err)
            }
          })
        })
        
        const timeoutPromise = new Promise((_, reject) =>
          setTimeout(() => reject(new Error('timeout')), 1000)
        )
        
        const token = await Promise.race([tokenPromise, timeoutPromise])
        
        if (token) {
          hiddenInput.value = token
        }
      } catch (err) {
        console.error('[RECAPTCHA] Error:', err.message)
      }
      
      // Reset button before submitting
      if (submitBtn) {
        submitBtn.disabled = false
        if (submitBtn.tagName === 'INPUT') {
          submitBtn.value = originalText
        } else {
          submitBtn.textContent = originalText
        }
      }
      
      this.recaptchaProcessed = true
      this.element.requestSubmit()
    }
  }
}

